import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";

import Link from "@components/link";

import { sendNavigationMetric } from "../../../../utils/sendMetric";

import strings from "../../../../locales/strings";

import styles from "./SearchRestrictionMessage.scss";

const cx = classNames.bind(styles);

const emailRegex = /[^@]+@[^.]+\..+/;
const phoneRegex = /^\+\d{1,15}(?:\s\d{1,15})*$/;
const russionPhoneRegex = /^89\d{9}$/;

const SearchRestrictionMessage = ({ searchPhrase, isPaidUser, baseUrl }) => {
  const isEmail = !!searchPhrase && emailRegex.test(searchPhrase);
  const isPhone = !!searchPhrase && phoneRegex.test(searchPhrase);
  const isRussianPhone = !!searchPhrase && russionPhoneRegex.test(searchPhrase);
  const canShowMessage = !isPaidUser && (isEmail || isPhone || isRussianPhone);

  if (!canShowMessage) {
    return null;
  }

  return (
    <div className={cx("search-restriction")}>
      <span>{strings.search_phoneAndEmailRestriction}</span>
      <Link
        className={cx("search-restriction-link")}
        target="_blank"
        rel="noopener noreferrer"
        href={`https://billing.${baseUrl}/addinvoice?utm_content=fast_search&utm_source=header&utm_campaign=new_header`}
        onClick={() => sendNavigationMetric("SEARCH_RESTRICTION_BILLING")}
        preventDefault={false}
      >
        {strings.search_pricesAndRates}
      </Link>
    </div>
  );
};

SearchRestrictionMessage.propTypes = {
  searchPhrase: PropTypes.string,
  isPaidUser: PropTypes.bool,
  baseUrl: PropTypes.string,
};

export default SearchRestrictionMessage;
